<div class="flex h-full w-full">
    <div class="rsc-container flex flex-auto justify-center items-center content-center">
        <label>{{selectedCount | number}} of {{totalCount | number}} selected</label>
    </div>
</div>
